/**
 * Delays for the number of milliseconds
 * @param ms
 */
export default function delay(ms) {
    return new Promise((resolve) => {
        const timeout = setTimeout(() => {
            if (timeout) {
                clearTimeout(timeout);
            }
            resolve();
        }, ms);
    });
}
